<template>
  <div>
    <b-navbar class="sticky-top" toggleable="lg" type="dark">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
            id="navItemATH"
            class="custom-nav-title"
            style="width: 7em"
            @click="goToTop()"
            to="/ath-games"
            >ATH GAMES</b-nav-item
          >
          <b-nav-item class="custom-nav-title" style="width: 4em" to="/team"
            >TEAM</b-nav-item
          >
          <b-nav-item
            id="nav1"
            class="custom-nav-title disabled-link"
            style="width: 4.5em"
            v-on:click="onDisabledClick"
            >GAMES</b-nav-item
          >
          <b-nav-item
            class="custom-nav-title"
            to="/tokenomics"
            style="width: 7.5em"
            >TOKENOMICS</b-nav-item
          >

          <b-nav-item-dropdown
            text="HOW TO BUY"
            style="width: 7.5em"
            class="custom-nav-title"
          >
            <b-dropdown-item to="/android"> ANDROID </b-dropdown-item>
            <b-dropdown-item to="/ios">IOS</b-dropdown-item>
            <b-dropdown-item href="#" disabled>
              <span style="color: gray !important">DESKTOP</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item
            id="nav4"
            class="custom-nav-title disabled-link"
            style="width: 4em"
            v-on:click="onDisabledClick"
            >SWAP</b-nav-item
          >
          <b-nav-item
            id="nav5"
            class="custom-nav-title disabled-link"
            style="width: 7em"
            v-on:click="onDisabledClick"
            >WHITEPAPER</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <NavPopovers v-if="popovers" />

    <audio id="song" src="../assets/audio/song.wav" autoplay></audio>
    <button
      class="audio-player red-button center-vertical center-horizontal"
      @click="toggleAudio()"
    >
      <i :class="audioClass"></i>
    </button>

    <div style="position: relative">
      <router-view class="view" style="overflow-x: hidden !important" />
    </div>

    <FooterPopOvers v-if="popovers" />

    <div class="footer center-vertical text-xs">
      <div class="footer-left">
        <a
          class="disabled-link"
          id="footer1"
          href="#"
          v-on:click="onDisabledClick"
          ><img
            src="../assets/img/logos/CoinMarketCap_Logo.png"
            alt=""
            class="footer-logo"
          />
          COINMARKETCAP</a
        >
        <a
          class="bold-hover"
          href="https://www.coingecko.com/en/coins/ath-games"
          target="_blank"
        >
          <img
            src="../assets/img/logos/Coingecko_logo.png"
            alt=""
            class="footer-logo"
          />COINGECKO</a
        >
        <a
          class="bold-hover"
          href="https://bscscan.com/token/0x632a21a913a4b59b561b999cf473109e37e87b39"
          target="_blank"
          ><img
            src="../assets/img/logos/BSCscan_Logo.png"
            alt=""
            class="footer-logo"
          />BSCSCAN</a
        >
      </div>
      <div class="center-horizontal" style="width: 100%">
        <div>
          <div>
            <a
              class="footer-links sub-page-link"
              @click="goToPage('privacy-policy')"
              href="#privacy-policy"
              >PRIVACY POLICY</a
            ><span>|</span>
            <a
              class="footer-links sub-page-link"
              @click="goToPage('terms-of-service')"
              href="#terms-of-service"
              >TERMS OF SERVICE</a
            >
            <span>|</span>
            <a
              class="footer-links"
              href="https://docs.google.com/forms/d/e/1FAIpQLSfTfcKmY5MU0ICmPaLMWCc3u7XT3Z7aheIPPVQXU6MMMAX4IQ/viewform?vc=0&c=0&w=1&flr=0"
              target="_blank"
              >CONTACT US</a
            >
          </div>
          <p style="margin-bottom: 0px">
            COPYRIGHT 2021 ATH GAMES. ALL RIGHTS RESERVED
          </p>
        </div>
      </div>
    </div>
    <div
      class="center-vertical"
      style="
        z-index: 10;
        right: 2vw;
        bottom: 2vw;
        position: fixed;
        display: grid;
        grid-template-columns: repeat(2, auto);
        grid-column-gap: 0.5vw;
      "
    >
      <button
        class="red-button red-button-question"
        @click="goToWindow('https://t.me/+6UijN2qKLIFkMjU0')"
      >
        ?
      </button>
      <button class="red-button red-button-up" @click="goToTop()">
        <img src="../assets/img/button-arrow-up.svg" />
      </button>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import NavPopovers from "../components/NavPopovers.vue";
import FooterPopOvers from "../components/FooterPopovers.vue";

export default {
  name: "App",
  data() {
    return {
      windowWidth: window.innerWidth,
      audioClass: "fas fa-volume-up",
      audioPauseClass: "fas fa-volume-mute",
      audioPlayClass: "fas fa-volume-up",
    };
  },
  mounted() {
    $(".nav-item a").on("click", function () {
      $(".nav-item a").removeClass("router-link-active");
      $(this).addClass("router-link-active");
    });
    $(".sub-page-link").on("click", function () {
      $(".nav-item a").removeClass("router-link-active");
    });

    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  destroyed() {
    window.removeEventListener("resize", this);
  },
  computed: {
    popovers() {
      return this.windowWidth > 992;
    },
  },
  components: {
    NavPopovers,
    FooterPopOvers,
  },
  methods: {
    goToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    goToPage(page) {
      this.$router.push({ name: page });
    },
    onDisabledClick(e) {
      e.preventDefault();
      return false;
    },
    goToWindow(url) {
      window.open(url);
    },
    toggleAudio() {
      let song = document.getElementById("song");
      if (song == null) return;

      this.audioClass = song.muted ? this.audioPlayClass : this.audioPauseClass;

      song.muted = !song.muted;
    },
  },
};
</script>

<style>
@import "../assets/css/style.css";

.bold-hover:hover {
  font-weight: 600;
}
.coming-soon > .popover-body {
  background-color: transparent;
  border-radius: 0.5em;
  margin: -0.5em;
  padding: 0.5em 1em 0.5em 1em;
  color: white;
  background-color: var(--red);
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
    rgba(0, 0, 0, 0.22) 0px 15px 12px;
  font-size: clamp(0.45rem, 1vw, 1rem);
}

.disabled-link {
  opacity: 0.5 !important;
}

.disabled-link a {
  font-weight: 400 !important;
  border-bottom: none !important;
}

.footer-logo {
  display: none;
  width: 4em;
  margin-right: 0.5em;
}
.footer {
  position: relative;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: var(--darkgray);
}
.footer a {
  text-decoration: none !important;
}
.footer-left {
  position: absolute;
  left: 1vw;
  display: grid;
  grid-template-columns: repeat(3, 14em);
}
.footer-links {
  padding-left: 0.5em;
  padding-right: 0.5em;
  color: white;
}

.custom-nav-title {
  margin-left: 1.5em !important;
  margin-right: 1.5em !important;
  padding: 0 !important;
}

.dropdown-menu {
  background-color: var(--darkgray-navbar) !important;
}

.dropdown-item:hover {
  background-color: transparent !important;
  border-bottom: none !important;
  font-weight: 600;
}
.navbar {
  padding-left: 1vw;
  background-color: var(--darkgray-navbar);
}

.nav-item a {
  height: 2.5em;
  border-bottom: 0.6em solid var(--red);
  border-bottom-style: hidden;
}

.nav-item a.router-link-active {
  border-bottom: 0.6em solid var(--red);
}

.red-button-up {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
    rgba(0, 0, 0, 0.22) 0px 15px 12px;
  border-radius: 50%;
  min-height: 50px;
  min-width: 50px;
  max-width: 130px;
  max-height: 130px;
  width: 3vw;
  height: 3vw;
}

.red-button-up img {
  width: 55%;
}

.red-button-question {
  font-weight: 600;
  font-size: clamp(16px, 1vw, 4rem);
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
    rgba(0, 0, 0, 0.22) 0px 15px 12px;
  border-radius: 50%;
  min-height: 25px;
  min-width: 25px;
  max-width: 130px;
  max-height: 130px;
  width: 1.9em;
  height: 1.9em;
}

.audio-player {
  color: white;
  border: none;
  position: fixed;
  font-size: clamp(15px, 2vw, 80px);
  min-height: 25px;
  min-width: 25px;
  max-width: 130px;
  max-height: 130px;
  width: 3vw;
  height: 3vw;
  right: 1vw;
  top: 1vw;
  z-index: 1021;
}

@media (max-width: 992px) {
  .navbar {
    background-color: var(--darkgray);
  }
  .custom-nav-title {
    width: 100% !important;
    margin: 0 !important;
  }
  .navbar-nav a {
    height: auto;
  }
  .navbar-nav a.router-link-active {
    border-bottom: none;
    border-bottom-style: hidden;
  }
  .dropdown-menu {
    text-align: center !important;
  }
  .audio-player {
    right: 2vw;
    top: 3vw;
  }
}
</style>
